import { useRecoilValue } from 'recoil'
import selfOrganizationAtom from '../selfOrganization.atom'

const useSelfOrganization = () => {
  const organization = useRecoilValue(selfOrganizationAtom).organization

  return organization
}

export default useSelfOrganization
